/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentMethodResponse } from "./PaymentMethodResponse";
import * as t from "io-ts";

// required attributes
const PaymentMethodsResponseR = t.interface({
  paymentMethods: t.readonlyArray(
    PaymentMethodResponse,
    "array of PaymentMethodResponse"
  )
});

// optional attributes
const PaymentMethodsResponseO = t.partial({});

export const PaymentMethodsResponse = t.intersection(
  [PaymentMethodsResponseR, PaymentMethodsResponseO],
  "PaymentMethodsResponse"
);

export type PaymentMethodsResponse = t.TypeOf<typeof PaymentMethodsResponse>;
